import React, { Component } from "react";
import {FormBlocks} from './FormBlocks';
import {formFieldsAttributes} from '../../FormBuilderFunctions/FieldProps';
import {currencyListUtil, getUserPreferredCurrencyCode, sanitizeCurrencyAmountInput, currencyAmountKeyPress} from '../../../../Utils/CommonFunctions';
import {callPOST} from '../../../../Utils/ApiUtil';
import Wrp from '../../../../hoc/Wrp/Wrp';
import ExchangeRateConversion from './ExchangeRateConversion';

const resolvePreferredCurrency = () => getUserPreferredCurrencyCode() || '';

const isCreateForm = () => {
  try {
    const path = (window.location && window.location.pathname) ? window.location.pathname : '';
    return path.indexOf('/add/') !== -1;
  } catch (e) {
    return false;
  }
};

const resolveCreateCurrency = (item) => {
  const preferredCurrency = resolvePreferredCurrency();
  const storedCode = item && item.currency_code;
  // Create forms always surface preferred (or org default) — layout often seeds CAD.
  if (isCreateForm() && preferredCurrency) {
    return preferredCurrency;
  }
  if (storedCode === undefined || storedCode === '' || storedCode === null) {
    return preferredCurrency || 'CAD';
  }
  return storedCode;
};

class Currency  extends Component {
  state ={
    historyCurrency:0,
    currentCurrenctValue:this.props.value,
    currencyValue:'',
    bottomPopup:false,
    historyPopup:false,
    isOpenCurrencyConversion:false,
    exchangeRates:{
      exchange_rate: '',
      from_currency_code: "",
      to_currency_code: "",
      value: ''
    }
  }
  toogleConvertCurrency = ()=>{
    const{isOpenCurrencyConversion} = this.state;
    this.setState({
        historyPopup: false,
        isOpenCurrencyConversion:!isOpenCurrencyConversion
    })
  }
  applyAndClose = (currencyValue, newCurrencyCode)=>{
    this.setState({
        isOpenCurrencyConversion:false,
        currencyValue:currencyValue
    });
    // Keep redux / select in sync with "Change Currency To" (subform select is disabled).
    if (newCurrencyCode) {
      this.props.onChangeInputAction(this.props.fieldObj, newCurrencyCode, 'currencyType');
    }
  }
  
    toFixedHandler = (value) =>{
      const decimal = (this.props.item && this.props.item.decimal && this.props.item.decimal!==null)? this.props.item.decimal :(this.props.item && this.props.item.decimal_places && this.props.item.decimal_places!==null)?this.props.item.decimal_places:2;
      value = (value)?value:0;
      return parseFloat(value).toFixed(decimal);
    }
    // componentDidUpdate(){
    //     console.log(this.props);
    // }
    showHistoryPopup = ()=>{
      this.setState(prevState => ({
        historyPopup: !prevState.historyPopup
      }));
    }
    
    currencyOnBlur = (value)=>{
      value = sanitizeCurrencyAmountInput(value);
      const fixedValue = this.toFixedHandler(value);
      this.setState({currencyValue:fixedValue,currentCurrenctValue:value,bottomPopup:false});
      this.props.onChangeInputAction(this.props.fieldObj,fixedValue,'number')
      this.props.onBlurHandlerAction(this.props.fieldObj,fixedValue,'number')
    }
    setHistoryValue= () =>{
      this.setState({currencyValue:this.state.historyCurrency,historyPopup:false});
    }
    currencyOnChange =(value)=>{
      value = sanitizeCurrencyAmountInput(value);
      try{
        this.setState({currencyValue:value,currentCurrenctValue:value,bottomPopup:false});
        this.props.onChangeInputAction(this.props.fieldObj,value,'number')
      }catch(e){
        console.log(e);
      }
    }  
    componentDidMount = ()=>{
     
      const updateData = {
        ...this.props.fieldObj,
        ...this.props.subformObj
      }
      const attr = formFieldsAttributes(
        {...this.props.item,className:this.props.className,hideMandatory:true,
      },this.props.validationForms,e =>this.currencyOnChange(updateData,e))
      this.setState({currencyValue:attr.value});
      const selectedCurrency = resolveCreateCurrency(this.props.item);
      const storedCode = this.props.item && this.props.item.currency_code;
      const storedFrom = this.props.item && this.props.item.from_currency;
      const storedRate = this.props.item && this.props.item.exchange_rate;
      const isSubform = this.props.formType === 'SUBFORM'
        || (this.props.fieldObj && (this.props.fieldObj.subFormIndex !== undefined || this.props.fieldObj.rowIndex !== undefined));
      // Detail-view create flow: on new/missing companions, store from == to and rate 1.
      // Create forms must persist selectedCurrency (preferred), not layout's CAD default —
      // otherwise the select shows preferred currency while save still writes CAD.
      const needsCreateCompanions = !storedCode
        || !storedFrom
        || storedRate === undefined || storedRate === null || storedRate === ''
        || (isCreateForm() && storedCode !== selectedCurrency)
        || (isSubform && (!storedFrom || String(storedFrom).trim() === ''));
      if (needsCreateCompanions) {
        const preferCreateCurrency = isCreateForm() && !!selectedCurrency;
        const toCode = preferCreateCurrency ? selectedCurrency : (storedCode || selectedCurrency);
        // When replacing a create-form CAD/default with preferred, align from + rate.
        const alignToPreferred = preferCreateCurrency && storedCode !== selectedCurrency;
        const fromCode = (!alignToPreferred && storedFrom && String(storedFrom).trim() !== '')
          ? storedFrom
          : toCode;
        const rateToStore = (!alignToPreferred && storedRate !== undefined && storedRate !== null && storedRate !== '')
          ? storedRate
          : 1;
        this.props.onChangeInputAction(this.props.fieldObj, fromCode, 'fromCurrency');
        this.props.onChangeInputAction(this.props.fieldObj, toCode, 'currencyType');
        this.props.onChangeInputAction(this.props.fieldObj, rateToStore, 'exchangeRate');
      }
     } 

  //CURRENCY LIST CHANGE HANDLER   
  currenctyListChangeHandler = (e)=>{
    const value = e.target.value;
    const {item} = this.props;
    const currentCurrency = (item.currency_code===undefined || item.currency_code==='')
      ? (resolvePreferredCurrency() || getUserPreferredCurrencyCode() || 'CAD')
      : item.currency_code;
    this.updateCurrencyValueByFormat({
      fromCode:currentCurrency,
      toCode:value,
      selectedValue:item.selectedValue,
    });
    this.props.onChangeInputAction(this.props.fieldObj, currentCurrency, 'fromCurrency');
    this.props.onChangeInputAction(this.props.fieldObj,value,'currencyType');
  } 
  updateCurrencyValueByFormat = (param,has_currency_conversion=false)=>{
    const fromCode = String(param.fromCode || '').trim().toUpperCase();
    const toCode = String(param.toCode || '').trim().toUpperCase();
    // Same currency (e.g. panel mount CAD→CAD): no lookup; avoid false FAIL toast on Edit.
    if (fromCode && toCode && fromCode === toCode) {
      if (has_currency_conversion === true) {
        this.setState({
          exchangeRates: {
            exchange_rate: 1,
            value: param.selectedValue,
            from_currency_code: fromCode,
            to_currency_code: toCode,
            rate_unavailable: false
          }
        });
      }
      return;
    }
    let API_Url = "currency/convert";
    const payload={
	    from_currency_code:param.fromCode,
	    to_currency_code:param.toCode,
	    value: param.selectedValue
	  }
    const onRateUnavailable = () => {
      if (has_currency_conversion === true) {
        this.setState({
          exchangeRates: {
            exchange_rate: '',
            value: param.selectedValue,
            from_currency_code: param.fromCode,
            to_currency_code: param.toCode,
            rate_unavailable: true
          }
        });
      }
    };
    callPOST(API_Url,payload)
      .then(res => {
        const response = res && res.data;
        if(res.status===200 && response && response.code===200){ 
              const responseData = response.data;
              let convertedValue = this.toFixedHandler(responseData.value);
                if(has_currency_conversion===false){
                  this.props.onChangeInputAction(this.props.fieldObj,convertedValue,'number');
                  if (responseData.exchange_rate !== undefined && responseData.exchange_rate !== null && responseData.exchange_rate !== '') {
                    this.props.onChangeInputAction(this.props.fieldObj, responseData.exchange_rate, 'exchangeRate');
                  }
                  this.setState({
                    exchangeRates:responseData,
                    currencyValue:convertedValue,
                    bottomPopup:false});
                }else{
                  this.setState({
                    exchangeRates:{ ...responseData, rate_unavailable: false },
                  });
                }
        } else {
          onRateUnavailable();
        }     
      })
    .catch(() => {
      onRateUnavailable();
    })
  }   
  render() {
    const  {
      type,
      item,
      className,
      validationForms,
      section,
      fieldObj,
    } = this.props;
    // console.log('this.props.',this.props,fieldObj);
    const updateData = {
     ...fieldObj
    }
    const attr = formFieldsAttributes(
      {...item,className:className,hideMandatory:true,
    },validationForms)
    const currencyList =  currencyListUtil();
    const selectedCurrency = resolveCreateCurrency(item);
    // item.has_currency_conversion = true;
    let readonlyVal = false;
    if(attr.fieldAttributes && attr.fieldAttributes.readOnly) {
       readonlyVal = attr.fieldAttributes.readOnly;
    }
  return (
      <FormBlocks {...this.props}  attr={attr}>
        <div className="input-group border-0">
          <div className="input-group-prepend">
          <select className="form-control" 
            disabled={(item.has_currency_conversion===true)?true:false}
            onChange={e=>this.currenctyListChangeHandler(e)} value={selectedCurrency}
            {...attr.fieldAttributes}>
            {currencyList.map((currency,currIndex)=>{
              return(
                <option key={currIndex}  value={currency.key}>{currency.value}</option>
              )
            })}
            </select>
          </div> 
          <input 
            type={type}
            value={this.state.currencyValue}
            inputMode="decimal"
            {...attr.fieldAttributes}
            onKeyPress={currencyAmountKeyPress}
            onChange={e =>this.currencyOnChange(e.target.value)}
            onBlur={e =>this.currencyOnBlur(e.target.value)}
          />
          {(item.has_currency_conversion===true)?
           <Wrp>
            <ExchangeRateConversion
            {...this.props} 
            currency_code={selectedCurrency}
            currencyValue={this.state.currencyValue}
            toogleConvertCurrency={this.toogleConvertCurrency}
            isOpenCurrencyConversion={this.state.isOpenCurrencyConversion}
            updateCurrencyValueByFormat={this.updateCurrencyValueByFormat}
            exchangeRates={this.state.exchangeRates}
            applyAndClose={this.applyAndClose}
            toFixedHandler={this.toFixedHandler}
            currencyList={currencyList} />
            {/*
            {(this.state.isOpenCurrencyConversion===true)?
              <div className="bg-overlay overlayVisible" style={{zIndex:'999'}}></div>
            :''}
            */}
            </Wrp>
          :''}
          
          
          
          {(this.state.bottomPopup && this.state.currencyValue!==0)?
          <div onClick={this.currencyOnBlur.bind(this.state.currencyValue)} className={"card currencyPop"}>
            <div className="card-body p-1">={this.state.currentCurrenctValue}</div>
          </div>
        :''}
        { readonlyVal !== true ?
          <div className={(item.required===true)? 'mandatory input-group-append':'input-group-append'}  data-original-title="" adata-toggle="popover" data-content={this.state.historyCurrency+"="+eval(this.state.historyCurrency)} data-placement="bottom"> <a className="input-group-text" onClick={this.showHistoryPopup}><i className="fas fa-info"></i></a>
          </div>
        : null }
          
         {(this.state.historyPopup)?
          <div className="card currencyPop">
            <div className="card-body p-1" onClick={this.setHistoryValue} >{this.state.historyCurrency+"="+eval(this.state.historyCurrency)}</div>
          </div>
        :''}
      </div>
      
      
      </FormBlocks>
    );
  }
}

Currency.defaultProps = {
  className: "form-control",
}

export default Currency;
